import "./index.scss";
import React from "react";
import { createPortal } from "react-dom";

import Icon from "../appShell/icons";

// The app's one dialog. It is used both as a modal form and as a "please
// wait" curtain, so the close button only appears when there is something for
// it to close.
//
// It renders in a portal on `document.body`. Inline, `position: fixed` was
// being trapped by the page wrapper - that element keeps a filled transform
// from its enter animation, which makes it the containing block for anything
// fixed inside it - so the overlay covered the panel but not the rail or the
// top bar, and the scrim stopped in a hard line down the middle of the screen.
const Modal = ({ show, setShow, title, style, children, content, spanStyle }) => {
  if (!show) return null;

  return createPortal(
    <div className="au-modal" style={style}>
      <div className="au-modal-card" style={spanStyle}>
        {(title || setShow) && (
          <header className="au-modal-head">
            <h2 className="au-modal-title">{title}</h2>
            {setShow && (
              <button
                type="button"
                className="au-modal-close"
                onClick={() => setShow(false)}
                aria-label="Close"
              >
                <Icon name="close" size={16} strokeWidth="2" />
              </button>
            )}
          </header>
        )}

        <div className="au-modal-body">{children || content}</div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
